import React from "react"
import { connect } from "react-redux"
import { eapiClient } from "../../../../restClient"
import { Translations } from "../../../../utils"
import AddSweepInstruction from "./AddSweepInstruction"

class CaptureSweepInstructions extends React.Component {
    constructor(props) {
        super(props)
        this.state = {
        }
    }


    getTranslation = (key) => {
        return Translations(key, this.props.lang.currentLang.lang, this.props.lang.translatedData)
    }

    getCashConStatus = () => {
        const { sweepId, glsId } = this.props.match.params;
        if (sweepId && glsId) {
            const apiUrl = `/sows/gls/${glsId}/${sweepId}/sweepInstructionsStatus`
            eapiClient(apiUrl).then(({ data }) => {
                if (data.responseData) {
                    this.setState({ sowCashConTabStatus: data.responseData })
                }
            })
        }
    }

    render() {
        return (
            <article className="gls-sow-participants-accounts">
                <AddSweepInstruction
                    match={this.props.match}
                    history={this.props.history}
                    getCashConStatus={this.getCashConStatus}
                    sowCashConTabStatus={this.state.sowCashConTabStatus}
                ></AddSweepInstruction>
            </article>
        )
    }
}

const mapStateToProps = state => {
    return {
        customer: state.auth.userDetails,
        lang: state.lang,
        sowAgent: state.sowEntities.sowAgent,
    }
}

export default connect(mapStateToProps, null)(CaptureSweepInstructions)


// WEBPACK FOOTER //
// ./src/components/SowBody/GLSProduct/CaptureSweepInstructions/index.js